import React from 'react';
import { ChevronRight } from 'lucide-react';

interface TableOfContentsProps {
  chapters: {
    title: string;
  }[];
  activeChapter: number | null;
  onChapterSelect: (index: number) => void;
}

export function TableOfContents({ chapters, activeChapter, onChapterSelect }: TableOfContentsProps) {
  return (
    <div className="lg:col-span-1">
      <div className="bg-white dark:bg-accessible-gray-800 high-contrast:bg-black p-6 rounded-lg shadow-lg sticky top-24">
        <h2 className="heading-4 mb-6">
          Spis treści
        </h2>
        <button
          onClick={() => onChapterSelect(null)}
          className={`w-full text-left px-4 py-3 rounded-lg transition-colors flex items-center justify-between mb-2 ${
            activeChapter === null
              ? 'bg-accessible-red-600 text-white'
              : 'hover:bg-accessible-gray-100 dark:hover:bg-accessible-gray-700 text-accessible-gray-700 dark:text-accessible-gray-300'
          }`}
        >
          <span className={activeChapter === null ? '!text-white' : 'nav-link'}>Pokaż całość</span>
          <ChevronRight className={`w-4 h-4 transition-transform ${
            activeChapter === null ? 'rotate-90' : ''
          }`} aria-hidden="true" />
        </button>
        <nav className="space-y-2">
          {chapters.map((chapter, index) => (
            <button
              key={index}
              onClick={() => {
                onChapterSelect(index);
                document.getElementById(`chapter-${index}`)?.scrollIntoView({ behavior: 'smooth' });
              }}
              className={`w-full text-left px-4 py-3 rounded-lg transition-colors flex items-center justify-between ${
                activeChapter === index
                  ? 'bg-accessible-red-600 text-white'
                  : 'hover:bg-accessible-gray-100 dark:hover:bg-accessible-gray-700 text-accessible-gray-700 dark:text-accessible-gray-300'
              }`}
            >
              <span className={activeChapter === index ? '!text-white' : 'nav-link'}>{chapter.title}</span>
              <ChevronRight className={`w-4 h-4 transition-transform ${
                activeChapter === index ? 'rotate-90' : ''}`} 
                aria-hidden="true" 
              />
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
}